import styles from './FormSurvey.module.css'
import { SurveyButtonsQuestion, SurveyFieldTypes, SurveyFormStep, SurveyFreeTextQuestion } from '@/interfaces/survey_types'
import { useSurveyStore } from '@/stores/useSurveyStore'
import FreeTextQuestion from '../../Questions/FreeTextSurveyField/FreeTextQuestion'
import ButtonsQuestion from '../../Questions/ButtonsQuestion/ButtonsQuestion'
import MultiChoiceQuestion from '../../Questions/MultiChoiceQuestion/MultiChoiceQuestion'

interface FormSurveyProps extends React.ComponentProps<'div'> {
  submit: () => void
}

export default function FormSurvey ({ submit, ...rest }: FormSurveyProps) {
  const { survey, currentStep } = useSurveyStore()

  const contentStep = survey !== null ? survey.steps[currentStep] as SurveyFormStep : undefined

  if (!contentStep) return null

  return (
    <div className={styles.formSurveyWrapper} {...rest}>
      <div className={styles.contentWrapper}>
        {contentStep.title && contentStep.title !== '' &&
          <p className={`title3`}>{contentStep.title}</p>
        }

        {contentStep.subtitle && contentStep.subtitle !== '' &&
          <p className={`title3`}>{contentStep.subtitle}</p>
        }

        {contentStep.questions.length > 0 && contentStep.questions.map((item, i) => {
          switch (item.type) {
            case SurveyFieldTypes.MULTI_CHOICE:
              return <MultiChoiceQuestion
                        key={i}
                        data={item}              
                      />
            case SurveyFieldTypes.FREE_TEXT:
              return <FreeTextQuestion
                        key={i}
                        data={item as SurveyFreeTextQuestion}
                      />
            case SurveyFieldTypes.BUTTONS:
              return <ButtonsQuestion
                        key={i}
                        data={item as SurveyButtonsQuestion}
                        submit={submit}
                      />
            default:
              return null
          }
        })}
      </div>
    </div>
  )
}